import { Codebook } from '../Codebook'
import { CountryId } from '../country/CountryId'

export enum VATTypeId {
  ZERO_RATE = 1,
  WITHOUT_VAT_PAYMENT = 2,
  REDUCED_RATE = 3,
  SECOND_REDUCED_RATE = 4,
  BASIC_RATE = 5,
  WITHOUT_VAT_PAYMENT_EU_COUNTRIES = 6,
  NOT_VAT_PAYER = 7,
  THIRD_REDUCED_RATE = 8,
  WITHOUT_VAT_PAYMENT_MEDICAL = 9,
  WITHOUT_VAT_PAYMENT_EDUCATIONAL = 10,
}

export class VATType extends Codebook<VATTypeId> {
  static readonly ZERO_RATE = new VATType(VATTypeId.ZERO_RATE)
  static readonly WITHOUT_VAT_PAYMENT = new VATType(VATTypeId.WITHOUT_VAT_PAYMENT)
  static readonly REDUCED_RATE = new VATType(VATTypeId.REDUCED_RATE)
  static readonly SECOND_REDUCED_RATE = new VATType(VATTypeId.SECOND_REDUCED_RATE)
  static readonly BASIC_RATE = new VATType(VATTypeId.BASIC_RATE)
  static readonly WITHOUT_VAT_PAYMENT_EU_COUNTRIES = new VATType(
    VATTypeId.WITHOUT_VAT_PAYMENT_EU_COUNTRIES,
  )
  static readonly NOT_VAT_PAYER = new VATType(VATTypeId.NOT_VAT_PAYER)
  static readonly THIRD_REDUCED_RATE = new VATType(VATTypeId.THIRD_REDUCED_RATE)
  static readonly WITHOUT_VAT_PAYMENT_MEDICAL = new VATType(VATTypeId.WITHOUT_VAT_PAYMENT_MEDICAL)
  static readonly WITHOUT_VAT_PAYMENT_EDUCATIONAL = new VATType(
    VATTypeId.WITHOUT_VAT_PAYMENT_EDUCATIONAL,
  )

  static getDefault(countryId: CountryId): VATType {
    switch (countryId) {
      case CountryId.DEU:
      case CountryId.HUN:
      case CountryId.POL:
        return VATType.BASIC_RATE
      default:
        return VATType.REDUCED_RATE
    }
  }

  static nonVatPayerZeroType(countryId: CountryId): VATType {
    switch (countryId) {
      case CountryId.HUN:
        return VATType.NOT_VAT_PAYER
      case CountryId.ROU:
        return VATType.WITHOUT_VAT_PAYMENT
      default:
        return VATType.ZERO_RATE
    }
  }
}
